import {
    isAllAllowed,
    isAllowed,
    isAnyAllowed,
} from 'src/components/auth/permissions'

const checkPermissions = (userData, permissions) => {
    if (!Object.keys(permissions || {}).length) {
        return true
    }

    if (typeof permissions === 'string') {
        return isAllowed(userData, permissions)
    }

    const { anyOf = [], allOf = [] } = permissions
    let hasAnyOfPermissions, hasAllOfPermissions

    hasAnyOfPermissions = anyOf.length ? isAnyAllowed(userData, anyOf) : true
    hasAllOfPermissions = allOf.length ? isAllAllowed(userData, allOf) : true
    return hasAnyOfPermissions && hasAllOfPermissions
}

export default checkPermissions
